/**
 * Authentication event tracking
 */

import { analytics } from '../index';

export const authEvents = {
  /**
   * Track user signup
   */
  trackSignup: async (data: {
    method: 'email' | 'google' | 'github' | 'other';
    referralSource?: string;
  }) => {
    await analytics.track('user_signup', {
      category: 'auth',
      method: data.method,
      referral_source: data.referralSource,
    });
  },

  /**
   * Track user login
   */
  trackLogin: async (data: {
    method: 'email' | 'google' | 'github' | 'other';
    isReturning: boolean;
  }) => {
    await analytics.track('user_login', {
      category: 'auth',
      method: data.method,
      is_returning: data.isReturning,
    });
  },

  /**
   * Track user logout
   */
  trackLogout: async (data?: {
    reason?: 'user_initiated' | 'session_expired' | 'other';
  }) => {
    await analytics.track('user_logout', {
      category: 'auth',
      reason: data?.reason || 'user_initiated',
    });
  },

  /**
   * Track email verification
   */
  trackEmailVerified: async () => {
    await analytics.track('email_verified', {
      category: 'auth',
    });
  },

  /**
   * Track password reset request
   */
  trackPasswordResetRequested: async () => {
    await analytics.track('password_reset_requested', {
      category: 'auth',
    });
  },

  /**
   * Track password reset completed
   */
  trackPasswordResetCompleted: async () => {
    await analytics.track('password_reset_completed', {
      category: 'auth',
    });
  },

  /**
   * Track OAuth connection
   */
  trackOAuthConnected: async (provider: string) => {
    await analytics.track('oauth_connected', {
      category: 'auth',
      provider,
    });
  },

  /**
   * Track failed login attempt
   */
  trackLoginFailed: async (data: {
    method: string;
    errorType: 'invalid_credentials' | 'account_locked' | 'network_error' | 'other';
  }) => {
    await analytics.track('login_failed', {
      category: 'auth',
      method: data.method,
      error_type: data.errorType,
    });
  },

  /**
   * Track account deletion
   */
  trackAccountDeleted: async (data: {
    reason?: string;
    hadActiveSubscription: boolean;
  }) => {
    await analytics.track('account_deleted', {
      category: 'auth',
      reason: data.reason,
      had_active_subscription: data.hadActiveSubscription,
    });
  },
};